module.exports = __webpack_public_path__ + "img/hof_5.22cf6bdb.jpg";